import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { fakeTableList, schema } from "./parts";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_AGE002, httpAPI_AGE003 } from "./api/request";
import { Box } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";

/**
 * SCRC100003 代行者　新規登録
 * @returns JSX.Element
 */
const SCRC100003 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [openSuccess, setOpenSuccess] = useState(false);
  const [formData, setFormData] = useState<any>();

  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  const handleInit = async () => {
    // 代行者参照API 実行
    try {
      const res = await httpAPI_AGE002({ userId: location.state.userId });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        resArr.find((item) => item.keyword === "name")!.setDefaultValue =
          res?.name;
        resArr.find((item) => item.keyword === "email")!.setDefaultValue =
          res?.email;
        resArr.find((item) => item.keyword === "email2")!.setDefaultValue =
          res?.email;

        setStatecorpInfoList(resArr);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setStatecorpInfoList(stateFakeTableList.current);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    location.state?.userId
      ? handleInit()
      : setStatecorpInfoList(stateFakeTableList.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCheckAndSubmit = (data: any) => {
    if (data.email !== data.email2) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0001E",
      });
      return;
    }

    setFormData(data);
    setOpenSuccess(true);
    setState({
      ...state,
      errorMsgId: "",
    });
  };

  const handleOK = async () => {
    // 代行者更新API 実行
    try {
      const res = await httpAPI_AGE003({
        userId: location.state?.userId,
        contractorNo: state.authInfo?.contractorNo,
        name: formData.name,
        email: formData.email,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        if (
          state.authInfo?.userType ===
          authorityUserType.userTypeNumber.KEIYAKUSYA
        ) {
          navigate("/SCRC100002");
        } else {
          navigate("/SCRD310001");
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC100003" data-testid="SCRC100003PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC100003_01}</TkInfoManual>

      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={(data) => {
          onCheckAndSubmit(data);
        }}
        buttonGroup={
          <Box className="btn">
            <TkBackButton></TkBackButton>
          </Box>
        }
        submitButtonGroup={[
          {
            submitButtonText: "登録",
            submitButtonDisabled: false,
          },
        ]}
      />
      <TkMessageDialog
        data-testid="dialogTest"
        open={openSuccess}
        onOky={handleOK}
        onCancel={() => setOpenSuccess(false)}
        title={"確認（代行者を登録します）"}
        contextText={"　代行者を登録します。よろしいですか？"}
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC100003;
